module.exports = __webpack_public_path__ + "img/xhs.741c9b8b.png";